/**
 * Utility methods.
 */
export class Utility {
    /**
    * Get query string value.
    */
    public static getQueryVariable(variable): string {
        let query: string = decodeURIComponent(window.location.search.substring(1));
        let vars: string[] = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return null;
    }

    public static deepEqual(x, y) {
        return (x && y && typeof x === 'object' && typeof y === 'object') ?
            (Object.keys(x).length === Object.keys(y).length) &&
            Object.keys(x).reduce(function (isEqual, key) {
                return isEqual && Utility.deepEqual(x[key], y[key]);
            }, true) : (x === y);
    }

    public static updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf('#');
        var hash = i === -1 ? ''  : uri.substr(i);
             uri = i === -1 ? uri : uri.substr(0, i);

        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            uri = uri + separator + key + "=" + value;
        }
        return uri + hash;  // finally append the hash as well
    }
}


// WEBPACK FOOTER //
// ./src/app/utility.ts